export default "__VITE_ASSET__e282f247__"